import { faker } from '@faker-js/faker';

const userRoles = ['System Admin', 'Office Admin', 'Sale Manager', 'Finance'];
const statuses = ['Activate', 'Deactivate'];
const customerCategoriesName = [
    'Retail',
    'Wholesale',
    'Cooperate Clients',
    'Non Profit Organizations',
    'Government Agencies',
];
const customerTypes = ['New', 'Existing'];
const productNames = ['Pencil', 'Pen', 'Paper', 'Mechanical Pencil'];
const productTags = ['P', 'MP', 'NPP', 'Mp'];
const salePrices = [800, 1200, 5800, 1000, 1500];
const warehouses = ['Warehoue 1', 'Warehoue 2', 'Warehoue 3', 'Warehoue 4'];
const regions = ['Region 1', 'Region 2', 'Region 3', 'Region 4'];

export const createOfficeUser = () => ({
    user_id: faker.string.uuid(),
    username: faker.internet.userName(),
    email: faker.internet.email(),
    phone1: faker.phone.number(),
    phone2: faker.phone.number(),
    user_role_name:
        userRoles[
            faker.datatype.number({
                min: 0,
                max: userRoles.length - 1,
            })
        ],
    status: statuses[
        faker.datatype.number({
            min: 0,
            max: statuses.length - 1,
        })
    ],
});

export const createUserRole = () => ({
    user_role_id: 1,
    name: 'System Admin',
});

export const createCustomerCategory = () => ({
    customerCategoryId: ['CC10001'][
        faker.datatype.number({
            min: 0,
            max: ['CC10001'].length - 1,
        })
    ],
    customerCategoryName:
        customerCategoriesName[
            faker.datatype.number({
                min: 0,
                max: customerCategoriesName.length - 1,
            })
        ],
});

export const createCustomer = () => ({
    customer_id: 'CUS10001',
    customer_first_name: faker.internet.userName(),
    customer_last_name: faker.internet.userName(),
    customer_type_name:
        customerTypes[
            faker.datatype.number({
                min: 0,
                max: customerTypes.length - 1,
            })
        ],
    customer_phone1: faker.phone.number(),
    customer_email: faker.internet.email(),
    contactPersonPhoneNumber: faker.phone.number(),
    contactPersonFirstName: faker.internet.userName(),
    contactPersonLastName: faker.internet.userName(),
    contactPersonEmail: faker.internet.email(),
    divisionName: faker.internet.userName(),
    cityName: faker.internet.userName(),
    townshipName: faker.internet.userName(),
    customer_address: faker.address.streetAddress(),
    wayName: faker.internet.userName(),
    customer_category_name: 'Retail',
    vipStatus: 0,
    creditType: faker.internet.userName(),
    creditLimit: 0,
    remark: '',
    description: '',
});

export const createProductCategory = () => ({
    product_category_id: ['PPC000001'][
        faker.datatype.number({
            min: 0,
            max: ['PPC000001'].length - 1,
        })
    ],
    product_category_name: faker.internet.userName(),
});

export const createProductTag = () => ({
    product_tag_name: faker.internet.userName(),
});

export const createBrand = () => ({
    brand_id: ['BBC000001'][
        faker.datatype.number({
            min: 0,
            max: ['BBC000001'].length - 1,
        })
    ],
    brand_name: faker.internet.userName(),
    product_category_name: faker.internet.userName(),
});

export const createUnit = () => ({
    unit_id: faker.string.uuid(),
    unit_name: faker.finance.currencyCode(),
    base_unit_status: ['Yes', 'No'][
        faker.datatype.number({
            min: 0,
            max: ['Yes', 'No'].length - 1,
        })
    ],
});

export const createUnitOfConversion = () => ({
    base_unit_name: faker.finance.currencyCode(),
    base_qty: 1,
    converted_unit_name: faker.finance.currencyCode(),
    converted_qty: 10,
});

export const createBusinessUnit = () => ({
    customer_name: faker.internet.userName(),
    business_unit_name: faker.internet.userName(),
    business_unit_id: 'BUS10001',
});

export const createCustomerUser = () => ({
    user_id: faker.string.uuid(),
    username: faker.internet.userName(),
    email: faker.internet.email(),
    phone1: faker.phone.number(),
    phone2: faker.phone.number(),
    user_role_name:
        userRoles[
            faker.datatype.number({
                min: 0,
                max: userRoles.length - 1,
            })
        ],
    business_unit_name: 10,
    status: statuses[
        faker.datatype.number({
            min: 0,
            max: statuses.length - 1,
        })
    ],
});

export const createProduct = () => ({
    product_id: faker.string.uuid(),
    product_code: 'P100001',
    barcode: '102578102156',
    product_name:
        productNames[
            faker.datatype.number({
                min: 0,
                max: productNames.length - 1,
            })
        ],
    product_category_name: 'Office Supplies',
    product_tag_name:
        productTags[
            faker.datatype.number({
                min: 0,
                max: productTags.length - 1,
            })
        ],
    product_type_name: 'Ballpoint Pens',
    unit_name: 'Pack of 12',
    primary_sales_price:
        salePrices[
            faker.datatype.number({
                min: 0,
                max: salePrices.length - 1,
            })
        ],
    primary_sales_tax: 5,
    primary_sales_tax_type: 'Percentage',
    secondary_sales_price:
        salePrices[
            faker.datatype.number({
                min: 0,
                max: salePrices.length - 1,
            })
        ],
    secondary_sales_tax: 7,
    secondary_sales_tax_type: 'Percentage',
    direct_sales_price:
        salePrices[
            faker.datatype.number({
                min: 0,
                max: salePrices.length - 1,
            })
        ],
    direct_sales_tax: 8,
    direct_sales_tax_type: 'Percentage',
});

export const createWay = () => ({
    way_id: 'WA00002',
    way_name: 'North Bahan Trip',
    warehouse_name:
        warehouses[
            faker.datatype.number({
                min: 0,
                max: warehouses.length - 1,
            })
        ],
    region_name:
        regions[
            faker.datatype.number({
                min: 0,
                max: regions.length - 1,
            })
        ],
});

export const generateFakeData = async <T>(
    callback: any,
    count: number
): Promise<T[]> => {
    // Wait for 3 seconds
    await new Promise((resolve) => setTimeout(resolve, 1000));

    return faker.helpers.multiple(callback, {
        count,
    });
};
